import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, useParams, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { CartProvider } from "./context/CartContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";
import FAQ from "./pages/FAQ";
import Videos from "./pages/Videos";
import PR from "./pages/PR";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import SaleBanner from "./components/SaleBanner";
import { useSale, countdownSale } from "./utils/sale";
import { Toaster } from "sonner";
import { getProduct } from "./api/api";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Layout({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  const sale = useSale();
  const showBanner = !isAdmin && !!countdownSale(sale);
  return (
    <>
      {!isAdmin && <SaleBanner />}
      {!isAdmin && <Navbar bannerActive={showBanner} />}
      <div style={showBanner ? { paddingTop: "36px" } : undefined}>{children}</div>
      {!isAdmin && <Footer />}
    </>
  );
}

// Redirect old /products/:id URLs to new /products/:category/:slug URLs
function LegacyProductRedirect() {
  const { categoryOrId } = useParams();
  const [redirectPath, setRedirectPath] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const lookup = async () => {
      try {
        // If numeric, it's an old product ID — look it up and redirect
        if (/^\d+$/.test(categoryOrId)) {
          const product = await getProduct(categoryOrId);
          if (product && product.slug && product.category) {
            setRedirectPath(`/products/${product.category}/${product.slug}`);
            return;
          }
        }
      } catch { /* not a valid product ID */ }
      setIsLoading(false);
    };
    lookup();
  }, [categoryOrId]);

  if (redirectPath) return <Navigate to={redirectPath} replace />;
  if (isLoading && /^\d+$/.test(categoryOrId)) return null;
  // Not a numeric ID — treat as category filter on Products page
  return <Products />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <CartProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:categoryOrId" element={<LegacyProductRedirect />} />
              <Route path="/products/:category/:slug" element={<ProductDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/videos" element={<Videos />} />
              <Route path="/videos/:section/:slug" element={<Videos />} />
              <Route path="/pr" element={<PR />} />
              <Route path="/pr/:slug" element={<PR />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order-success" element={<OrderSuccess />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </Layout>
          <Toaster position="top-right" />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
